import { Component, Vue,Inject } from 'vue-property-decorator';
import appconst from './appconst'
import ajax from './ajax'
export default class AbpBase extends Vue{
    //全局类

    //表格
    table = {
        loading:false,
        queryString:'',
        status:true,
        totalCount:0,
        pageSize:10,
        page:1,
    }
    L(value:string,source?:string,...argus:string[]):string{
        if(source){
            return window.abp.localization.localize(value,source,argus);
        }else{
            return window.abp.localization.localize(value,appconst.localization.defaultLocalizationSourceName,argus);
        }
        
    }
    hasPermission(permissionName:string){
        return window.abp.auth.hasPermission(permissionName);
    }
    hasAnyOfPermissions(...argus:string[]){
        return window.abp.auth.hasAnyOfPermissions(...argus);
    }
    hasAllOfPermissions(...argus:string[]){
        return window.abp.auth.hasAllOfPermissions(...argus);
    }
    /**
     * 获取浏览器显示高度
     */
    getClientHeight() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    }
    //获取助记符
    async GetPinYinAndWubi(payload:any){
        let res = await ajax.get(`/api/services/app/ChsHelper/GetPinYinAndWubi`,{params:payload},false)
	    return res.data.result
    }
    //综合查询
    async GetSetting(payload:any){
        let res = await ajax.get(`/api/services/app/QuerySqlSetting/GetQuerySqlSetting`,{params:payload},false)
	    return res.data.result
    }
    //跟进配置查询详细信息
    async PageData(payload:any){
        let data = JSON.parse(JSON.stringify(payload));
        let res = await ajax.post(`/api/services/app/QuerySqlSetting/SinglePageData`,data,false)
	    return res.data.result
    }
    //钻取
    async GetQuerySetting(payload:any){
        let res = await ajax.get(`/api/services/app/QuerySqlSetting/GetQuerySetting`,{params:payload},false)
	    return res.data.result
    }
    async DrillData(payload:any){
        let res = await ajax.post(`/api/services/app/QuerySqlSetting/DrillData`,payload,false)
	    return res.data.result
    }
    //获取租户列表
    async QueryTenant(payload:any){
        let res = await ajax.post('api/services/app/Purchase/QueryTenant',payload,false)
        return res.data.result
    }
    //配置字典
    async QuerySysDicType(){
        let res = await ajax.post('api/services/app/Materials/QuerySysDicType',{},false)
        return res.data.result
    }
    async QuerySysDic(payload:any){
        let res = await ajax.post('api/services/app/Materials/QuerySysDic',payload,false)
        return res.data.result
    }
    async QueryCreateSysDic(payload:any){
        let res = await ajax.post('api/services/app/Materials/QueryCreateSysDic',payload,false)
        return res.data.result
    }
    async QueryEditSysDic(payload:any){
        let res = await ajax.post('api/services/app/Materials/QueryEditSysDic',payload,false)
        return res.data.result
    }
    async QueryDeleteSysDic(payload:any){
        let res = await ajax.post('api/services/app/Materials/QueryDeleteSysDic',payload,false)
        return res.data.result
    }
    // 公用查询返回展示方式处理
    /**
     * @param chartType 显示类型
     * @param data  数据源
     * @param index 下标
     * @param columns 列表
     * @return Object {index:对应下标，data:图表所需数据对象}}
     */
    renderData(chartType:any,data:Array<any>,index:number,columns:Array<any>){
        let list = [];
        let object = null;
        for (let i = 0; i < data.length; i++) {
            let type = chartType;
            let item = data[i];
            //条形图-柱状图-折线曲线图-面积堆积图
            if(type==14){
                object = item
            //表格
            }else if(type==12){
                let row = {};
                item.forEach((v:any,i:any)=>{
                    row['k'+i] = item[i]
                })
                list.push(row);
            }
        }
        if(chartType < 7){
            //去掉分组条件
            let noGroup = columns[index].queryResultDto.filter((item:any)=>{return item.displayType == 1})
            
            //行列转换
            //定义一个新的数组
            var data_new=[];
            //初始化，定下有多少行
            console.log(data)
            for (var i=0;i<data[0].length;i++ ){
                data_new[i]=[];
            }
            //遍历旧数组
            for (var i=0;i<data.length ;i++ )//控制有几个元素
            {   
                for (var j=0;j<data[i].length ;j++ )//遍历每一个具体的值
                {
                    data_new[j][i]=data[i][j];
                }
            }
            //拿到第一组为分组分组条件
            console.log(data_new)
            
            //余下为结果数据组
            let ddata = data_new.filter((item:any,i:any)=>{return i!=0})
            

            list = noGroup.map((item:any,gindex:any)=>{
                return {
                    grouplist:data_new.filter((item:any,i:any)=>{return i==0}),
                    name:item.columnComment,
                    type:chartType===1|| chartType===2?'bar':'line',
                    smooth:chartType===4|| chartType===6?true:false,
                    data:ddata[gindex],
                    areaStyle: chartType===5|| chartType===6?{normal:{}}:{normal:{opacity: 0}}, //区域面积
                    markLine : {
                        data : [
                            {type : 'average', name : '平均值'}
                        ]
                    },
                    markPoint : {
                        data : [
                            {type : 'max', name : '最大值'},
                            {type : 'min', name : '最小值'}
                        ]
                    }
                }
            })
        }
        // 饼
        if(chartType==7 || chartType==8 || chartType==10){
            columns[index].column = data.map((c:any,i:any)=>{
                return c[0]
            })
            object =  [{
                name:columns[index].name,
                type:chartType === 10?'funnel':'pie',
                radius: chartType === 7 ? ['40%','60%'] :'60%',
                center: ['50%', '50%'],
                data:data.map((c:any,i:any)=>{
                    return {
                        value:c[1], name:c[0]
                    }
                }),
                label: {
                    normal: {
                        show: false,
                        position: 'center'
                    },
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
            }]          
        }else if(chartType==9){
            columns[index].column = data.map((c:any,i:any)=>{
                return c[0]
            })
            object = [{
                name:columns[index].name,
                type:'pie',
                radius: chartType === 7 ? ['40%','60%'] :'60%',
                center: ['50%', '50%'],
                data:data.map((c:any,i:any)=>{
                    return {
                        value:c[1], name:c[0]
                    }
                }).sort(function (a, b) { return a.value - b.value; }),
                roseType: 'radius',
                label: {
                    normal: {
                        formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                        backgroundColor: '#eee',
                        borderColor: '#aaa',
                        borderWidth: 1,
                        borderRadius: 4,
                        rich: {
                            a: {
                                color: '#999',
                                lineHeight: 22,
                                align: 'center'
                            },
                            hr: {
                                borderColor: '#aaa',
                                width: '100%',
                                borderWidth: 0.5,
                                height: 0
                            },
                            b: {
                                fontSize: 12,
                                lineHeight: 22
                            },
                            per: {
                                color: '#eee',
                                backgroundColor: '#334455',
                                padding: [2, 4],
                                borderRadius: 2
                            }
                        }
                    }
                },
                labelLine: {
                    normal: {
                        lineStyle: {
                            color: '#000'
                        },
                        smooth: 0.2,
                        length: 10,
                        length2: 20
                    }
                },
                animationType: 'scale',
                animationEasing: 'elasticOut',
                animationDelay: function (idx) {
                    return Math.random() * 200;
                }
            }]           
        }
        return {
            index:index,
            data:object?object:list,
        }
    }
    /**
     * @param chartType 显示类型
     *  条形图 = 1,
        柱状图 = 2,
        折线图 = 3,
        曲线图 = 4,
        折线面积图 = 5,
        曲线面积图 = 6,
        圆环图 = 7,
        饼图 = 8,
        饼图显示信息 = 9,
        漏斗图 = 10,
        多数据柱状图 = 11,
        表格 = 12,
        地图 = 13,
        卡片 = 14,
    */
    getChartsType(type:number){
        switch (type){
            case 1:
            return 'bar-across'
            case 2:
            return 'bar'
            case 3:
            return 'bar'
            case 4:
            return 'bar'
            case 5:
            return 'bar'
            case 6:
            return 'bar'
            case 7:
            return 'pie'
            case 8:
            return 'pie'
            case 9:
            return 'pie'
            case 10:
            return 'funnel'
        }
    }
    formatDate(arg: any){
        if (arg && typeof arg === "object") {
            return arg.Format('yyyy-MM-dd')
        } else if (typeof arg === 'string' && arg.indexOf('T') !== -1) {
            return arg.split('T')[0]
        } else if (typeof arg === 'string' && arg.indexOf(' ') !== -1) {
            return arg.split(' ')[0]
        } else {
            return arg
        }
    }
    //树结构数据处理
    /* @param beforeData 原数据
     * @param afterData  处理后数据
     * @param props 数据结构
     * @param pid 标识父级
     * @param id 标识子级
     */
    getTree(beforeData:any,afterData:any,props:any,pid:any,id:any){
        //取得一级菜单的数据
        var baseNode = beforeData.filter(function(element) {
            return !element[pid]
        })
        baseNode.forEach(item => {
            //数据结构和源数据匹配
            let ips = {};
            for (const key in props) {
                const element = props[key];
                ips[key] = item[element]
            }
            afterData.push({...ips,children:[]})
        });
        this.getTreeChildren(beforeData,afterData,props,pid,id)
    }
    getTreeChildren(beforeData:any,afterData:any,props:any,pid:any,id:any){
        let self = this;
        afterData.forEach(function(elemet, index) {
            beforeData.forEach((item)=> {
                if(item[pid] == elemet[id]){
                    //数据结构和源数据匹配
                    let ips = {};
                    for (const key in props) {
                        const element = props[key];
                        ips[key] = item[element]
                    }
                    elemet.children.push({...ips,children:[]})
                }
            })
            if(elemet.children.length > 0) {
                self.getTreeChildren(beforeData,elemet.children,props,pid,id)
            }
        })
    }
}